import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { apiFetch } from 'utils/apiFetch'

export type PlannedNodesRepositionMeta = routes.ServiceCenterPlannedNodeReposition.Request

const request = async (meta: PlannedNodesRepositionMeta): Promise<PlannedNodesRepositionMeta> => {
  await apiFetch({ url: '/service-center-pseudonodes-reposition', body: meta })

  return meta
}

const callback = (meta: PlannedNodesRepositionMeta) => {
  serviceCenterStore.actions.repositionPseudoNodes(meta.pseudonodes)
}

export const serviceCenterPlannedNodesReposition = {
  request,
  callback,
}
